var _circle, _circle2, _g, _g2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertLight = function SvgAlertLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 63,
    fill: "none",
    viewBox: "0 0 63 63"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.191,
    height: 33.191,
    x: 15.668,
    y: 28.998
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#alert-light_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#alert-light_svg__b)",
    shapeRendering: "crispEdges",
    transform: "rotate(-15 32.264 42.945)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.264,
    cy: 42.945,
    r: 6,
    fill: "url(#alert-light_svg__c)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32.264,
    cy: 42.945,
    r: 6,
    fill: "url(#alert-light_svg__d)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.264,
    cy: 42.945,
    r: 5.5,
    stroke: "#232323",
    strokeOpacity: 0.05
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#alert-light_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.727 10.49A4 4 0 0 0 20 12.56"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 62.255,
    height: 58.525,
    x: 0,
    y: 2.172
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#alert-light_svg__f)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#alert-light_svg__g)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-light_svg__h)",
    fillOpacity: 0.5,
    d: "m10.956 44.489-.26-.966a3 3 0 0 1 2.122-3.675 3 3 0 0 0 2.121-3.674l-2.005-7.486c-2.109-7.868 2.56-15.956 10.43-18.065 7.868-2.108 15.956 2.562 18.064 10.43l1.942 7.245a3.25 3.25 0 0 0 3.98 2.298 3.25 3.25 0 0 1 3.98 2.298l.195.724a4 4 0 0 1-2.829 4.9l-32.841 8.8a4 4 0 0 1-4.9-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M23.493 11.106c7.602-2.037 15.415 2.475 17.452 10.077l1.942 7.244a3.75 3.75 0 0 0 4.592 2.652 2.75 2.75 0 0 1 3.368 1.944l.194.725a3.5 3.5 0 0 1-2.474 4.286l-32.842 8.8a3.5 3.5 0 0 1-4.286-2.475l-.26-.966a2.5 2.5 0 0 1 1.768-3.062 3.5 3.5 0 0 0 2.475-4.286l-2.006-7.486c-2.036-7.602 2.475-15.416 10.077-17.453Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 62.065,
    height: 38.731,
    x: 0.207,
    y: 22.337
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#alert-light_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#alert-light_svg__j)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-light_svg__k)",
    fillOpacity: 0.2,
    d: "M10.956 44.489a4.5 4.5 0 0 1 3.182-5.512l31.875-8.54a4.5 4.5 0 1 1 2.33 8.693l-31.876 8.54a4.5 4.5 0 0 1-5.511-3.181"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-light_svg__l)",
    d: "M10.956 44.489a4.5 4.5 0 0 1 3.182-5.512l31.875-8.54a4.5 4.5 0 1 1 2.33 8.693l-31.876 8.54a4.5 4.5 0 0 1-5.511-3.181",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "m14.267 39.46 31.876-8.54a4 4 0 0 1 2.07 7.727l-31.876 8.54a4 4 0 0 1-2.07-7.727Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 21.67,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#alert-light_svg__m)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#alert-light_svg__n)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert-light_svg__o)",
    d: "M32.264 13.945a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M38.264 8.445a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "alert-light_svg__b",
    width: 33.191,
    height: 33.191,
    x: 15.668,
    y: 28.998,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert-light_svg__e",
    width: 11.865,
    height: 9.037,
    x: 17.862,
    y: 6.523,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26731",
    result: "effect2_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert-light_svg__g",
    width: 62.255,
    height: 58.525,
    x: 0,
    y: 2.172,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert-light_svg__j",
    width: 62.065,
    height: 38.731,
    x: 0.207,
    y: 22.337,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert-light_svg__n",
    width: 33.188,
    height: 33.188,
    x: 21.67,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-light_svg__c",
    x1: 32.264,
    x2: 32.264,
    y1: 42.27,
    y2: 48.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-light_svg__h",
    x1: 27.02,
    x2: 32.275,
    y1: 23.306,
    y2: 42.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-light_svg__k",
    x1: 31.109,
    x2: 32.405,
    y1: 38.564,
    y2: 43.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert-light_svg__o",
    x1: 38.639,
    x2: 38.639,
    y1: 8.122,
    y2: 28.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-light_svg__a",
    transform: "translate(-15.668 -28.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.264,
    cy: 42.945,
    r: 6,
    transform: "rotate(-15 32.264 42.945)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-light_svg__f",
    transform: "translate(0 -2.172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.956 44.489-.26-.966a3 3 0 0 1 2.122-3.675 3 3 0 0 0 2.121-3.674l-2.005-7.486c-2.109-7.868 2.56-15.956 10.43-18.065 7.868-2.108 15.956 2.562 18.064 10.43l1.942 7.245a3.25 3.25 0 0 0 3.98 2.298 3.25 3.25 0 0 1 3.98 2.298l.195.724a4 4 0 0 1-2.829 4.9l-32.841 8.8a4 4 0 0 1-4.9-2.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-light_svg__i",
    transform: "translate(-.207 -22.337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.956 44.489a4.5 4.5 0 0 1 3.182-5.512l31.875-8.54a4.5 4.5 0 1 1 2.33 8.693l-31.876 8.54a4.5 4.5 0 0 1-5.511-3.181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-light_svg__m",
    transform: "translate(-21.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.264 13.945a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "alert-light_svg__d",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert-light_svg__p",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "alert-light_svg__l",
    width: 1.524,
    height: 7.111,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert-light_svg__p",
    transform: "scale(.00149 .00694)"
  })))));
};
export default SvgAlertLight;